// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"e6","bottomColumnWapper":"e6","bottom-column-panel":"e7","bottomColumnPanel":"e7"};